import { render, staticRenderFns } from "./AuthenticationModel.vue?vue&type=template&id=4871db41&scoped=true"
import script from "./AuthenticationModel.vue?vue&type=script&lang=js"
export * from "./AuthenticationModel.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationModel.vue?vue&type=style&index=0&id=4871db41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871db41",
  null
  
)

export default component.exports